<template>
  <component :is="component"></component>
</template>
<script>

import Func49Listagem from '@/views/49/Func49Listagem'

export default {
  name: 'Func10',
  data () {
    return {
      component: Func49Listagem
    }
  }
}
</script>
